export enum ConfigurationTabType {
  SYSTEM = 'system',
  USER_INFO_REQUIRED_FIELDS = 'user-info-required-fields',
  ERROR_MESSAGES = 'error-messages',
  HORMONE_PATTERN_CONTENTS = 'hormone-pattern-contents',
  STRAW_STAGE_CONTENTS = 'straw-stage-contents',
  CURRENT_CYCLE_CONTENTS = 'current-cycle-contents',
}
